/**
 * API: Carousel
 * ------------------------------------------------------------------------------
 * A standardised carousel component powered by Splide.js.
 * - https://splidejs.com/guides/getting-started/#basic-structure
 * - Splide API is very Framework-focused and lightweight.
 * - APIs and event emitters should be called on-demand within the component.
 * - Read docs for recommended element setups.
 */
import Splide from '@splidejs/splide'

/**
 * Create a new Carousel object.
 * @param {String} selector - Element selector.
 * @param {Object} config - Settings object defined when instantiating.
 */
export default function Carousel(selector, config) {

  /**
   * Carousel settings.
   * - Override these settings via the config parameter.
   */
  const nodeSelectors = {
    carousel: document.querySelector(selector),
  }

  if (!nodeSelectors.carousel) {
    return
  }

  const namespace = nodeSelectors.carousel.getAttribute('js-carousel')

  if (!namespace) {
    window.console.error('Error: carousel does not have a unique namespace.')
    return
  }

  /**
   * Initiate new Carousel instance with custom settings.
   */
  const carousel = new Splide(nodeSelectors.carousel, {
    arrows: false,
    drag: true,
    flickPower: 200,
    mediaQuery: 'min',
    pagination: false,
    type: 'loop',
    ...config,
  })

  return carousel
}
